const Caption = require("../../../../../dumb/Caption/C");
const {Box} = require("@material-ui/core");
const {TableMerchant} = require("../../../../../helpers/Table");
const {DisplayDataMerchant} = require("../../../../../dumb/DisplayData");
const React = require("react");
const Button = require("../../../../../dumb/Button/C");
const openPopupUserEdit = require("./openPopupUserEdit");
const reduce = require("mn-utils/reduce");
const upperFirst = require("mn-utils/upperFirst");
const openPopupResendInvite = require("./openPopupResendInvite");
const openPopupDeleteUser = require("./openPopupDeleteUser");
const {apiV2UsersList} = require("../../../../../../api/merchant/users");

module.exports = (props) => {
  const disabled = props.disabled || false;

  return (
    <>
      <Box width="100%" height="calc(100vh - 350px)" minHeight="500px">
        <TableMerchant
          getDataFromServer={apiV2UsersList}
          header={(update) => (
            <div className="layoutRow fhaS fvaC mb20">
              <Caption>
                User profiles
              </Caption>
              <Button
                className="ml10"
                disabled={disabled}
                onClick={() => openPopupUserEdit({}, update)}
              >
                Add user
              </Button>
            </div>
          )}
          columns={[
            {
              minWidth: 300,
              label: 'User email',
              dataKey: 'email',
              dataHandler: ({email}) => (
                <DisplayDataMerchant>
                  {email}
                </DisplayDataMerchant>
              )
            },
            {
              minWidth: 300,
              label: 'Role',
              dataKey: 'role',
              dataHandler: ({role}) => (
                <DisplayDataMerchant>
                  {role}
                </DisplayDataMerchant>
              )
            },
            {
              minWidth: 300,
              label: 'Permissions',
              dataKey: 'settings',
              dataHandler: ({settings}) => {
                const permissions = reduce(settings, (a, enabled, key) => {
                  enabled && a.push(upperFirst(key).replace(/_/gim, ' '));
                  return a;
                }, []).join(', ') || '-';

                return (
                  <Box width="70%">
                    <DisplayDataMerchant>
                      {permissions}
                    </DisplayDataMerchant>
                  </Box>
                )
              }
            }
          ]}
          actions={(data, update) => {
            const permissions = reduce(data.settings, (a, enabled, key) => {
              enabled && a.push(upperFirst(key).replace(/_/gim, ' '));
              return a;
            }, []).join(', ') || '-';

            const params = {
              ...data,
              permissions,
            };

            return ([
              {
                name: 'Resend invite',
                onClick() {
                  openPopupResendInvite(params);
                },
              },
              {
                name: 'Edit user',
                onClick() {
                  openPopupUserEdit(params, update);
                },
              },
              {
                name: (<div className="cF00">Delete user</div>),
                onClick() {
                  openPopupDeleteUser(params, update);
                },
              },
            ])
          }}
          disableFilters
        />
      </Box>
    </>
  );
};
